import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    requiremmentList: {
      marginTop: 15,
    },
    mt: {
      marginTop: 15,
    },
    label: {
      fontSize: 11,
      marginLeft: 6,
      color: theme.palette.primary.main,
    },
    radiosDescription: {
      marginLeft: 30,
      color: theme.palette.secondary.light,
      fontSize: 12,
      marginBottom: 12,
    },
    radiosLabel: {
      '& .MuiFormControlLabel-label': {
        fontWeight: 600,
        fontSize: 13,
        color: theme.palette.secondary.dark,
      },
    },
    radiosContainer: {
      marginTop: '15px',
      paddingLeft: '12px',
    },
    helpIconInline: {
      marginLeft: '0.5rem',
    },
    defaultTaxLabel: {
      display: 'flex',
      alignItems: 'center',
    },
  };
});

export default useStyles;
